import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "page-view__headline" }
const _hoisted_3 = { class: "page-view__title" }
const _hoisted_4 = {
  key: 0,
  class: "page-view__toolbar"
}
const _hoisted_5 = { class: "page-view__actions" }
const _hoisted_6 = { class: "page-view__body" }

import type { Component } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageView',
  props: {
    title: {},
    icon: {}
  },
  setup(__props: any) {

/* eslint-env vue/setup-compiler-macros */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "page-view",
    "aria-label": __props.title
  }, [
    _createElementVNode("header", {
      class: _normalizeClass(["page-view__header", { 'page-view__header--phase1-with-actions': _ctx.$slots.actions }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.icon)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), {
              key: 0,
              class: "page-view__icon",
              "aria-hidden": "true"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("h1", _hoisted_3, _toDisplayString(__props.title), 1)
      ]),
      (_ctx.$slots.actions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "actions")
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 8, _hoisted_1))
}
}

})